<template>
	<div class="customFixed-vue alertPOP darkFadeBG hedgePosition">
		<div v-if="instruments[symbol]">
		    <div class="custom-modal showTabs secondary-color headerTab openHeader" v-if="tempOrderId == ''">
			    <div class="mainContent position-relative">
			    	<div class="topSettingHead position-relative border-bottom p-3">
			    			<p class="f-14 mb-0">{{$t('hedge_position')}}</p>
							<span class="closePOP" @click.prevent="$parent.hedgePosition = {}"><feather size="13px" type="x"></feather></span>
			    		</div>
					<div class="mainTab-one sm p-3 mt-0">
						<span class="closePOP" @click="$parent.hedgePosition = {}"><feather size="13px" type="x"></feather></span>
				    	<form class="updateWrap">
						    <div class="oneColmn">
						    	<div class="d-flex align-items-center px-2 mb-3 justify-content-between">
							    		<div class="leftImp">
								    		<p class="f-14">{{trade.Symbol}}</p>
								    		<!-- <p class="sm date">{{trade.OpenTime | moment('HH:mm:ss - DD-MM-YYYY')}}</p> -->
								    	</div>
								    	<div class="rightImp">
								    		<p>{{$t('positions')}} <strong :class="sideClass[trade.Side]">{{sideValue[trade.Side]}}</strong></p>
								    	</div>
							    	</div>
							    <div class="includeLabe form-data">
							    	
								    <div class="form-fields mx-0 mb-3 pl-1">
								    	<div class="d-flex align-items-center lightBC justify-content-between pr-2">
											<label>{{ $t('price') }}</label>
											<span v-if="parseInt(trade.Side) == 0" class="green">{{instruments[symbol].B}}</span>
											<span v-else-if="parseInt(trade.Side) == 1" class="red">{{instruments[symbol].A}}</span>
											<!-- <input type="text" :placeholder="trade.Price" name="" disabled>
											<input type="text" :placeholder="trade.Price" name="" disabled> -->
										</div>
									</div>
								</div>
							</div>
						    <div class="twoColmn d-flex align-items-center px-3">
								<div class="form-fields mb-3 py-0">
									<span class="d-flex align-items-center justify-content-between">{{$t('lots')}} <strong>{{lot}}</strong></span>
								</div>
						    </div>
							<div class="fullWidh w-100 text-center mt-2 h-50p">
								<button class="btn appButton linkBG mx-auto justify-content-center large" :disabled="lot == 0" @click.prevent="placeOrder()">{{$t('submit')}}</button>
							</div>
						</form>
				    </div>
				</div>
		    </div>
		    <div class="custom-modal showTabs secondary-color headerTab openHeader p-4 text-center minCustom" v-else-if="tempOrderId != '' && !wsOrder.hasOwnProperty(tempOrderId)">
		    	<span class="closePOP" @click="$parent.hedgePosition = {}"><feather size="13px" type="x"></feather></span>
		    	<div class="ppSuccess-icon text-center mt-3 mb-2">
	                <feather size="28px" type="clock"></feather>
	            </div>
		    	<h3>{{$t('placed_order_pending_wait')}}</h3>
		    </div>
		    <div class="custom-modal showTabs secondary-color headerTab openHeader p-4 text-center minCustom" v-else-if="wsOrder.hasOwnProperty(tempOrderId)">
		    	<span class="closePOP" @click="$parent.hedgePosition = {}"><feather size="13px" type="x"></feather></span>
		    	<div class="ppSuccess-icon text-center mt-3 mb-2">
	                <feather size="28px" type="check-circle" v-if="wsOrder[tempOrderId].stat == 'OK'"></feather>
	                <feather size="28px" type="alert-triangle" v-else></feather>
	            </div>
		    	<h3 :class="(wsOrder[tempOrderId].stat == 'OK')?'green':'red'">{{wsOrder[tempOrderId].resp_msg}}</h3>
		    	<a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click.prevent="$parent.hedgePosition = {}">{{ $t('go_to_order') }}</a>
		    </div>
	    </div>
	    <div class="custom-modal showTabs secondary-color headerTab openHeader p-4 text-center minCustom" v-else>
	    	<span class="closePOP" @click="$parent.hedgePosition = {}"><feather size="13px" type="x"></feather></span>
	    	<div class="ppSuccess-icon text-center mt-3 mb-2">
                <feather size="28px" type="clock"></feather>
            </div>
	    	<app-loader/>
	    </div>
	</div>
</template>
<script>
import { Const } from '@/plugins/vue-provider-cache/const.mod';
import { commonAllmixins } from '@/plugins/commonAll';
const product = process.env.product;
export default {
    name: 'App-modify-open-order',
    mixins: [commonAllmixins],
    data() {
        return {
        	tab: 'modify', // modify, partial-close
        	placed:false,
        	tempOrderId: '',
            submitted: false,
			sideClass:{
                '1':'red',
                '0':'green',
            },
            sideValue:{
                '1':'Sell',
                '0':'Buy',
            },
            lot: '',
            symbol: '',
        }
    },
    props:['trade'],
    methods:{
    	placeOrder(){
    		var _that = this
    		this.submitted =  true
    		_that.$validator.validate().then(valid => {
				if (valid && !_that.orderPlacedWait) {
                    this.$store.commit('SET_WS_ORDER',{})
		    		const tempOrderId = new Date().getTime()
	    			this.submitted =  false
					let orderJson = {
						"symbol" : _that.trade.Symbol,
						"quantity" : parseFloat(_that.lot),
						"side" : (_that.trade.Side == 1)?0:1,
						"stop" : 0,
						"limit" : 0,
						"trail" : 0,
						"commentary" : 'Hedge-Position',
						"tempOrderId" : tempOrderId,
						"account_id": this.get_user.profile.act_account_id,
						'localParams' : _that
					}
					// console.log('order',orderJson)
					// if(product == 'act'){
						orderJson = {
							'symbol' : _that.trade.Symbol,
							'trade' : this.trade.TradeID,
							'quantity' : parseFloat(_that.lot),
							'tempOrderId' : tempOrderId
						}
						orderJson.trade = this.trade.TradeID;
						this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].hedgePosition(orderJson);
					// }else{
					// 	this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeOrder(orderJson);
					// }
					this.orderPending = orderJson;
					this.tempOrderId = this.orderPending.tempOrderId;
				}
			});
    	},
    	successWs(){
			// this.placed = true
        },
        failedWs(){
			this.displayError('faild to Hedge Position','error')
			this.tempOrderId = 'false'
			// this.$store.commit('SET_WS_ORDER',{})
        },
    	displayError(getMessage,type){
			this.$notify({
				group: 'foo',
				type: (type && type == null)?'error':type,
				text: getMessage,
				duration: 4000,
				closeOnClick: true
			});
		}
    },
    computed:{
    	instruments(){
    	    try {
	            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
	            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
	        } catch (ex) {                
	            return []
	        }
	    },
    },
    created(){
    	this.symbol = this.trade.Symbol;
    	let lotBy = 100000
    	try{
    		lotBy = this.currencyPairs.filter(val=>val.isinid.includes( this.trade.Symbol))[0].market_ContractSize || 100000
    	}catch(e){}
		this.lot = this.trade.Quantity?(this.trade.Quantity / lotBy):0
    }
}
</script>




// WEBPACK FOOTER //
// src/components/website/shared/order/modify-order/hedge-position.vue